import type { FC } from "react";
import React from "react";
import { useBloc } from "src/state/state";
import UserCubit, {
  ProfileProgramMembership
} from "src/state/UserCubit/UserCubit";
import { DebugToggleSwitch } from "./debug.styles";

const DebugActiveProgram: FC = () => {
  const [, { programMemberships, setProgramMemberships }] = useBloc(UserCubit);

  const activeProgram = programMemberships?.find(
    (program) => program.active || (!program.start && !program.end)
  );

  const setActiveProgram = (program: ProfileProgramMembership) => {
    setProgramMemberships(program);
  };

  return (
    <div>
      {Object.values(ProfileProgramMembership).map((program) => {
        const isActive = program === activeProgram?.program;
        return (
          <DebugToggleSwitch key={program}>
            <span className="label">{program}</span>
            <input
              type="checkbox"
              checked={isActive}
              onChange={() => setActiveProgram(program)}
            />
            <span className="switch" />
          </DebugToggleSwitch>
        );
      })}
    </div>
  );
};

export default DebugActiveProgram;
